import React from 'react'
import { Box, AppBar, Tabs, Tab } from '@mui/material'
import { TabPanel } from 'src/Components/Ui/TabPanel'
import { State, Position, Brand } from 'src/types'
import { FigureFront } from 'src/Components/Domain/FigureFront'
import { FigureBack } from 'src/Components/Domain/FigureBack'
import { useLocale } from 'src/locales/useLocale'
import { tabStyle } from 'src/Components/Domain/SettingTabs'

const devToolStyleFront = {
  backgroundImage: `url(${'/cmittFront2.jpeg'})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'left 70px top 5px',
  backgroundSize: '77%',
  maxWidth: '100%'
}

const devToolStyleBack = {
  backgroundImage: `url(${'/ragPitcher.jpg'})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'left 332px top 382px',
  backgroundSize: '35%',
  maxWidth: '100%'
  // transform: `rotate(5deg)`
}

export const a11yProps = (index: number): { id: string; 'aria-controls': string } => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`
})

type Props = {
  state?: State
  brand: Brand
  position: Position
  figurePanelNum: number
  handleFigurePanelNum: (event: any, newValue: 0 | 1) => void
}

export const Figures: React.FC<Props> = ({ state, brand, position, figurePanelNum, handleFigurePanelNum }) => {
  const { t } = useLocale()
  // this is devTools
  const [coordinateX, setCoordinateX] = React.useState(0)
  const [coordinateY, setCoordinateY] = React.useState(0)
  const [isCopy, setCopy] = React.useState(false)
  // const [isGenImg, setGenImg] = React.useState(false)
  // 例えばこんな感じの関数を判定を入れる
  // const isBrandParam = (x: unknown): x is Brand => {
  //   if (typeof x === 'string' && x === 'atoms') {
  //     return true
  //   }
  //   return false
  // }

  const handleCoordinate = (e: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => {
    // eslint-disable-next-line
    // @ts-ignore
    const rect = e.target.getBoundingClientRect()
    const x = parseInt(`${e.clientX - rect.left}`)
    const y = parseInt(`${e.clientY - rect.top}`)
    setCoordinateX(x)
    setCoordinateY(y)
    setCopy(false)
  }
  const devFlg = process.env.NEXT_PUBLIC_DEV_MODE === 'true' ? true : false
  if (!state) return <></>
  return (
    <Box mb={1}>
      <TabPanel selectedIndex={figurePanelNum} index={0}>
        <FigureFront
          {...{ state, position, brand, devFlg }}
          // 開発で座標を取得したいときは以下を有効にする
          devTools={{ coordinateX, coordinateY, isCopy, setCopy }}
          // devToolStyle={devToolStyleFront}
          handleCoordinate={handleCoordinate}
        />
      </TabPanel>
      <TabPanel selectedIndex={figurePanelNum} index={1}>
        <FigureBack
          {...{ state, position, brand, devFlg }}
          domId={'canvasBack'}
          // 開発で座標を取得したいときは以下を有効にする
          devTools={{ coordinateX, coordinateY, isCopy, setCopy }}
          // devToolStyle={devToolStyleBack}
          handleCoordinate={handleCoordinate}
        />
      </TabPanel>
      {brand === 'gorilla' && position === 'first' && (
        <Box px={1} textAlign="left" color={'red'} fontSize={'small'} bgcolor={'white'}>
          実際のウェブはクロスウェブになります。描画には反映されませんのでご注意ください。
        </Box>
      )}
      <AppBar position="static">
        <Tabs value={figurePanelNum} onChange={handleFigurePanelNum} aria-label="figure-tab-wrapper" centered>
          <Tab label={t.CATCH_SURFACE} {...a11yProps(0)} style={tabStyle(0, figurePanelNum)} />
          <Tab label={t.BACK_SURFACE} {...a11yProps(1)} style={tabStyle(1, figurePanelNum)} />
        </Tabs>
      </AppBar>
    </Box>
  )
}
